// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"RLTableLoader_loaderWrapper__3ZDMA","loader":"RLTableLoader_loader__kFM4t","text":"RLTableLoader_text__p6pKJ"};